export default __webpack_public_path__ + "static/media/3.2d3b4ae5.jpg";